import React from 'react';
import FormInsert from '../components/FormInsert/FormInsert.jsx';
import SlideBar from '../components/SliderBar/SliderBar.jsx';


export const Form = () => {
  return (
    <>
        <SlideBar />
        <FormInsert />
    </>
  );
}

export default Form;